import React, { useEffect, useState, useRef } from "react";
import "../../style/product.css";
import Button from "@material-ui/core/Button";
import axios from "axios";
import useConfirm from "../../components/Control/useConfirm";
import PublishIcon from "@material-ui/icons/Publish";
import { DivStyled } from "./container.style";

const AddEditDepartment = ({ id, setIsDepartmentModal }) => {
  const [departmentData, setDepartmentData] = useState({});
  const inputElement = useRef(null);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    "Department",
    `Are you sure you want to ${id ? "update" : "save"} this?`
  );

  function handleDepartmentData(e) {
    setDepartmentData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  useEffect(() => {
    if (inputElement.current) {
      inputElement.current.focus();
    }
  }, []);

  useEffect(() => {
    if (id) {
      axios
        .get(`/api/getOneDeparment/${id}`)
        .then((res) => setDepartmentData(res.data))
        .catch((err) => console.log(err));
    }
  }, [id]);

  const handleSumbit = async () => {
    // e.preventDefault();
    if (!departmentData.department_name) {
      alert("Department Name is required");
      return;
    }
    const ans = await confirmSubmit();
    if (!ans) {
      return;
    }

    if (id) {
      await axios
        .put(`/api/updateDepartment/${id}`, departmentData)
        .then((res) => {
          setIsDepartmentModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post("/api/createDepartment", departmentData)
        .then((res) => {
          setIsDepartmentModal(false);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <section className="root-admin">
      <div
        className="btn_save"
        style={{
          position: "absolute",
          right: "150px",
          top: "9px",
        }}
      >
        <Button
          type="submit"
          variant="outlined"
          color="white"
          size="large"
          style={{ color: "#e9e9e9" }}
          startIcon={<PublishIcon />}
          onClick={handleSumbit}
        >
          {id ? "UPDATE" : "SUBMIT"}
        </Button>
      </div>
      <DivStyled>
        <label htmlFor="department_name">Department Name:</label>
        <input
          type="text"
          id="department_name"
          name="department_name"
          ref={inputElement}
          // required
          defaultValue={departmentData?.department_name}
          onBlur={handleDepartmentData}
        />
      </DivStyled>
      <DivStyled>
        <label htmlFor="head_of_department"> Head Of Department:</label>
        <input
          type="text"
          id="head_of_department"
          name="head_of_department"
          defaultValue={departmentData?.head_of_department}
          onBlur={handleDepartmentData}
        />
      </DivStyled>
      <DialogSubmit isSubmitContent={false} />
    </section>
  );
};

export default AddEditDepartment;
